import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#3B5998",
      d: "M0 20c0 11.046 8.954 20 20 20s20-8.954 20-20S31.046 0 20 0 0 8.954 0 20Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M17.154 30h3.639v-9.995h2.73l.54-3.123h-3.27v-2.263c0-.73.471-1.496 1.146-1.496h1.858V10h-2.278v.014c-3.563.13-4.295 2.193-4.359 4.36h-.006v2.508h-1.82v3.123h1.82V30Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }